module.exports = __webpack_public_path__ + "img/magnifying-glass-solid.fa1271e3.svg";